


































import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  value: any
  showSummary: boolean
  totalPrice: number
  salePrice: number
}>(
  {
    props: ['value', 'showSummary', 'totalPrice', 'salePrice'],
  },
  () => class {},
)
